import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy as AngularTitleStrategy } from '@angular/router';
import { BreadcrumbService } from '../../backend/src/app/shared/modules/breadcrumb/breadcrumb.service';

@Injectable({providedIn: 'root'})
export class TitleStrategy extends AngularTitleStrategy {
    private readonly breadcrumb = inject(BreadcrumbService);
    private readonly title = inject(Title);

    buildTitle(): string | undefined {
        return this.breadcrumb.breadcrumb
            .map(part => part.label)
            .reduce((pageTitle, current) => pageTitle + ' - ' + current, '');
    }

    updateTitle(snapshot: RouterStateSnapshot): void {
        const title = this.buildTitle() || '';
        this.title.setTitle(`Baresto - ${this.prefix(snapshot)}${title}`);
    }

    private prefix(snapshot: RouterStateSnapshot): string {
        return snapshot.root.firstChild.data.prefixTitle;
    }
}
